import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { getNews, postAddNoticeRead } from "../../../../services/apiNews";

const NewsDetail = () => {
  // お知らせID
  const { id } = useParams();
  // お知らせ詳細データ
  const [detailData, setDetailData] = useState([]);

  // 初期レンダリング
  useEffect(() => {
    (async function () {
      const data = await getNews({ id });
      if (data == undefined || !data) return;
      setDetailData(data);

      if (!data.is_read) {
        // 既読登録
        postAddNoticeRead(data.id);
      }
    })();
  }, [id]);

  return (
    <>
      {detailData ? (
        <div className="l-page-right">
          <div className="l-page-con">
            <h1 className="p-heading01">{detailData.title}</h1>
            <div className="p-course__pageinfo">
              <p className="p-course__pagecat">{detailData.category_name}</p>
              <p className="p-course__pagedate">{detailData.date}</p>
            </div>
            <div className="p-course__pagecon">
              <>
                {detailData.content ? (
                  <span
                    className="text-break"
                    dangerouslySetInnerHTML={{
                      __html: detailData.content.replace(/\r?\n/g, "<br/>"),
                    }}
                  />
                ) : (
                  <></>
                )}
              </>

              <>
                {detailData.reference_url1 ||
                detailData.reference_url2 ||
                detailData.reference_url3 ? (
                  <div className="mt-5">
                    <p>■URL</p>
                    <ul>
                      {detailData.reference_url1 ? (
                        <li className="text-break">
                          URL1　
                          <a
                            href={detailData.reference_url1}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {detailData.reference_url1}
                          </a>
                        </li>
                      ) : (
                        <></>
                      )}
                      {detailData.reference_url2 ? (
                        <li className="text-break">
                          URL2　
                          <a
                            href={detailData.reference_url2}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {detailData.reference_url2}
                          </a>
                        </li>
                      ) : (
                        <></>
                      )}
                      {detailData.reference_url3 ? (
                        <li className="text-break">
                          URL3　
                          <a
                            href={detailData.reference_url3}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {detailData.reference_url3}
                          </a>
                        </li>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </div>
                ) : (
                  <></>
                )}
              </>
            </div>
          </div>
          <p className="p-news__back">
            <Link
              to={"/mypage/news/" + (detailData.published_to === 1 ? 1 : 2)}
              className="p-news__back-link"
            >
              一覧へ戻る
            </Link>
          </p>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default NewsDetail;
